@if (initialized) {

    @if (dcPageWidget) {
        <mvs-widget [widgetData]="dcPageWidget"></mvs-widget>
    }

    @if (dcPageContentWidget) {
        <mvs-widget [widgetData]="dcPageContentWidget"></mvs-widget>
    }

    @if (dcPageObjectWidget) {
        <mvs-widget [widgetData]="dcPageObjectWidget"></mvs-widget>
    }

    @if (dcPageTermWidget) {
        <mvs-widget [widgetData]="dcPageTermWidget"></mvs-widget>
    }

    @if (dcPageTypeWidget) {
        <mvs-widget [widgetData]="dcPageTypeWidget"></mvs-widget>
    }

    @if (dcPageTypeSectionWidget) {
        <mvs-widget [widgetData]="dcPageTypeSectionWidget"></mvs-widget>
    }


}